import clsx from 'clsx';
import React, { FC, MouseEvent } from 'react';

import styles from '~components/generic/elements/add-link/styles.css';

interface IAddLinkProps {
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  className?: {
    [className: string]: boolean;
  };
  children?: React.ReactNode;
}

const AddLink: FC<IAddLinkProps> = ({ className, onClick, children = '+ Add a new item' }) => (
  <a
    className={clsx({
      [styles.base]: true,
      'c-module--add-new-item': true,
      ...className,
    })}
    onClick={onClick}
  >
    {children}
  </a>
);

export default AddLink;
